import React, { useEffect, useState } from "react";
import { useAuth } from "./AuthContext";

type VisibilityContextType = {
  profileTypeId: number | undefined;
  canViewBaseballSchedule: boolean;
  canViewShowcaseData: boolean;
};

const VisibilityContext = React.createContext<VisibilityContextType | undefined>(undefined);

const VisibilityProvider: React.FC = ({ ...props }) => {
  const { user, asUser } = useAuth();
  const [profileTypeId, setProfileTypeId] = useState<number>();
  const [canViewBaseballSchedule, setCanViewBaseballSchedule] = useState(false);
  const [canViewShowcaseData, setCanViewShowcaseData] = useState(false);

  useEffect(() => {
    if (!!asUser) {
      setProfileTypeId(asUser?.profileTypeId);
    } else {
      setProfileTypeId(user?.profileTypeId);
    }
    // baseball schedule only visible for actual prospects not acting as prospect
    setCanViewBaseballSchedule(!!user?.canViewBaseballSchedule);
    setCanViewShowcaseData(!!user?.canViewShowcaseData || !!asUser?.hasEvent);
  }, [user, asUser]);

  return (
    <VisibilityContext.Provider
      value={{
        profileTypeId,
        canViewBaseballSchedule,
        canViewShowcaseData,
      }}
      {...props}
    />
  );
};

const useVisibility = (): VisibilityContextType => {
  const context: VisibilityContextType | undefined = React.useContext(VisibilityContext);
  if (context === undefined) {
    throw new Error(`useVisibility must be used within a VisibilityProvider`);
  }
  return context;
};

export { VisibilityProvider, useVisibility };
